export default "__VITE_ASSET__CNd0KgsC__"